<template>
  <div class="applets">
    <div class="decoration-common__style">
      <div class="hd-title clearfix">
        <span class="intro">电子屏ID：</span>
        <span class="txt">
          {{ screenId | formatLabelName(filterDownData('ledList')) }}
        </span>
        <span class="intro"> 装修页面名称：</span>
        <span class="txt">{{ pageName }}</span>
      </div>
      <div class="container-wrapper">
        <div class="electronic">
          <div class="decoration-wrap clearfix">
            <div class="box no-bor">
              <h3 class="title">模块可视化编辑浏览区域</h3>
              <p class="tips">
                该区域是一个可视化编辑的显示区域，鼠标在可视化编辑区域内点
                击对应的模块后，模块的右边就会弹出模块的编辑设置页面，当设
                置好模块数据时，该区域就会显示实时的编辑效果页面。
              </p>
              <div class="modules">
                <div class="electrinic-bg__frame">
                  <div class="carousel">
                    <el-carousel
                      height="44.4rem"
                      indicator-position="none"
                      arrow="never"
                      :interval="
                        (fileListLedBanner.adTime &&
                          fileListLedBanner.adTime * 1000) ||
                          1000
                      "
                    >
                      <el-carousel-item
                        v-for="(item, index) in fileListLedBanner.list"
                        :key="index"
                      >
                        <img :src="item.imgUrl" alt="" />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <i class="iconfont icon-ganying" />
                </div>
              </div>
            </div>
            <div class="box">
              <h3 class="title">模块属性设置区域</h3>
              <p class="tips">
                模块属性设置主要对各模块的图片上传的像素大小，链接，文本内
                容，排序，添加，保存，删除等进行设置。(拖拽排序~！)
              </p>
              <div class="modules">
                <div class="editor">
                  <draggable
                    v-bind="dragOptions"
                    v-model="fileListLedBanner.list"
                    @choose="setItemIndex"
                    tag="ul"
                    class="list"
                  >
                    <li
                      class="item Ad"
                      v-for="(item, index) in fileListLedBanner.list"
                      :key="index"
                    >
                      <div class="img">
                        <el-upload
                          class="BannerUpload"
                          ref="fileListLedBanner"
                          action="/"
                          accept=".jpg,.jpeg,.png"
                          :on-change="_handleAddItemData.bind(null, item)"
                          :on-remove="_handleRemove.bind(null, item)"
                          :http-request="_appendFormDataInfo.bind(null, item)"
                          :file-list="item.img"
                          list-type="picture-card"
                          :drag="true"
                          :auto-upload="false"
                        >
                          <i class="el-icon-plus" />
                        </el-upload>
                      </div>
                      <div class="input">
                        <el-input
                          type="text"
                          v-model="item.link"
                          required
                          placeholder="请输入链接地址"
                          clearable
                          class="intro"
                        />
                      </div>
                      <i
                        v-permission:del="$route.meta.permission"
                        class="iconfont icon-shanchu"
                        @click="delItem(fileListLedBanner.list)"
                      />
                    </li>
                  </draggable>
                  <el-button
                    v-permission:add="$route.meta.permission"
                    class="iconfont icon-xinzeng"
                    @click="moduleAddItem(fileListLedBanner.list, 'banner', 4)"
                  >
                    添加
                  </el-button>
                  <p class="tips">
                    *图片宽度640px，高度1920px，支持JPG/PNG格式
                  </p>
                  <div class="ad-time__select">
                    <span class="intro el-icon-time">广告时长</span>
                    <el-slider
                      v-model="fileListLedBanner.adTime"
                      :max="60"
                      :marks="marks"
                      tooltip-class="ad-tips"
                      :format-tooltip="formatTooltip"
                    >
                    </el-slider>
                  </div>
                  <el-button
                    size="98"
                    class="sub-color"
                    v-permission:save="$route.meta.permission"
                    @click="
                      moduleSaveData(fileListLedBanner, 'fileListLedBanner')
                    "
                  >
                    保存
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mask" v-if="dialogFormVisible">
        <el-dialog
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          :modal="false"
          custom-class="dialog"
          width="37.5rem"
          :center="true"
        >
          <el-form label-width="auto">
            <el-form-item label="电子屏ID：">
              <el-select v-model="screenId" placeholder="请选择" clearable>
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in filterDownData('ledList')"
                  :key="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="装修页面名称：">
              <el-input
                v-model="pageName"
                placeholder="请输入"
                clearable
                @click="dialogFormVisible = false"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              class="sub-color"
              size="98"
              @click="dialogFormVisible = false"
            >
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import decorationAppMxins from '../Mixins/'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'decorationElectronic',
  mixins: [decorationAppMxins, filterDownData],
  data() {
    this.renovationType = 'led'
    return {
      dialogFormVisible: true,
      screenId: '',
      pageName: '双十一促销页面',
      fileListLedBanner: {
        adTime: 3,
        list: [
          {
            img: [],
            imgUrl: '',
            link: ''
          },
          {
            img: [],
            imgUrl: '',
            link: ''
          },
          {
            img: [],
            imgUrl: '',
            link: ''
          }
        ]
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        const id = to.query.id
        if (id) this.dialogFormVisible = false
        this.screenId = to.query.ledId
        this._getDecorationDetails({
          renovation_id: id
        })
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 获取装修详情数据
     * @param params
     */
    _getDecorationDetails(params) {
      this.api.getDecorationDetails(params).then(res => {
        const adTime = res.renovation_info.fileListLedBanner.adTime
        if (adTime === '') {
          res.renovation_info.fileListLedBanner.adTime = 3
        }
        this.fileListLedBanner = res.renovation_info.fileListLedBanner
      })
    },
    /**
     * 广告时间toolTip格式化
     * @param val
     * @returns {string}
     */
    formatTooltip(val) {
      return `${val}s`
    }
  }
}
</script>

<style lang="scss">
.electronic {
  overflow: hidden;

  .decoration-wrap {
    .el-carousel__item:nth-child(2n) {
      background-color: #d3dce6;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #f3f3f3;
    }
  }
}
</style>
